<app-list-table-filters-wrapper
  [title]="'Crop identification' | translate"
  [parentRoute]="'/crop-identification'"
  [service]="service"
  [getAllMethod]="getAllMethod"
  [getTotalMethod]="getTotalMethod"
  [(filterModel)]="filterModel"
  [filtersForms]="filtersForms"
  (applyFilters)="applyFilters()"
  (clearFilters)="clearFilters()"
  [isLoading]="loading"
  [storageKey]="null"
  [toggleFilter]="toggleFilter"
  [filtersParams]="filtersParams"
  [columns]="tableColumns()"
>

  <ng-container controller>

    <app-export-button
      [loading]="isExporting()"
      [disabled]="isExporting()"
      (export)="onExport()">
    </app-export-button>
  </ng-container>

  <ng-template #regionTemplate let-row>
    <app-region-display [regionId]="row.region?.id || row.regionId || null"/>
  </ng-template>

  <ng-template #plannedCropTemplate let-row>
    @if (row.plannedCropNames) {
      {{ (row | serverTranslate:'plannedCropNames') || '-' }}
    } @else {
      -
    }
  </ng-template>

  <ng-template #areaTemplate let-row>
    <div class="flex flex-row-reverse w-full">
      <div class="flex-row-reverse">
        {{ (row.fieldArea | msfNumber) || '-' }}
      </div>
    </div>
  </ng-template>

  <ng-template #dateTemplate let-row>
    {{ row?.identificationDate | dateFormatLang: translateService.currentLang : true }}
  </ng-template>

  <ng-template #actionsTemplate let-row>
    <div class="crop-identification-list__actions">
      <button
        pButton
        type="button"
        icon="pi pi-camera"
        class="p-button-text p-button-sm"
        [pTooltip]="'Create request' | translate"
        [disabled]="!(row.field?.id || row.fieldId)"
        (click)="openCreateRequest(row, $event)">
      </button>
      <button
        pButton
        type="button"
        icon="pi pi-map-marker"
        class="p-button-text p-button-sm"
        [pTooltip]="'GO_TO_POINT' | translate"
        (click)="openOnGis(row, $event)">
      </button>
    </div>
  </ng-template>

  <ng-template #fieldTemplate let-row let-col="col">
    <app-field-passport-link
      [fieldId]="row.field?.id || row.fieldId || null"
      [fieldName]="row.field?.name || null"
    />
  </ng-template>

  <ng-template #sourceTemplate let-row>
    {{ row | serverTranslate:'aiInferenceImageDataSourceNames' }}
  </ng-template>

  <ng-template #culture1Template let-row>
    @if (row.topCandidates && row.topCandidates[0]) {
      {{ (row.topCandidates[0] | serverTranslate:'names') || '-' }}
    } @else {
      -
    }
  </ng-template>
  <ng-template #accuracy1Template let-row>
    @if (row.topCandidates && row.topCandidates[0]) {
      {{ row.topCandidates[0].score * 100 | number:'1.2-2':'en-US' }}%
    } @else {
      -
    }
  </ng-template>
  <ng-template #culture2Template let-row>
    @if (row.topCandidates && row.topCandidates[1]) {
      {{ (row.topCandidates[1] | serverTranslate:'names') || '-' }}
    } @else {
      -
    }
  </ng-template>
  <ng-template #accuracy2Template let-row>
    @if (row.topCandidates && row.topCandidates[1]) {
      {{ row.topCandidates[1].score * 100 | number:'1.2-2':'en-US' }}%
    } @else {
      -
    }
  </ng-template>
</app-list-table-filters-wrapper>
